import { render, staticRenderFns } from "./successPayuView.vue?vue&type=template&id=7ebfe938&"
import script from "./successPayuView.vue?vue&type=script&lang=js&"
export * from "./successPayuView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "successPayuView.vue"
export default component.exports